import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js';
import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js";

// Selectors
const SELECTORS = {
    ALL_INPUTS: '.ninja-forms-field:not(.select2-hidden-accessible)',
    FIELD_CONTAINER: '.nf-field-container',
    NINJA_FORMS_FIELD: '.ninja-forms-field',
    DATE_PICKER: '.date-container .datepicker',
    DATE_LABEL: '.date-container label',
    DATE_ICON: '.date-icon',
    DATE_INPUT: '.date-container .input',
    ABLESEDATUM_INPUT: '[name="ablesedatum"]',
    METER_READING_INPUT: '[name="meterReading"]',
    METER_READING_HT_INPUT: '[name="meterReadingHT"]',
    METER_READING_NT_INPUT: '[name="meterReadingNT"]',
    SWITCHER_RADIO: '.switcher-container input',
    SWITCHER_RADIO_CHECKED: '.switcher-container input:checked',
    FORM: '#ad-campaign',
    FORM_CONTAINER: '.form-box',
    LOADER: '#loader',
    RESPONSE_ERRORS: '.response-errors',
    SUBMIT_BUTTON: '[type="submit"]',
};

class AdCampaign {
    constructor() {
        this._loading = false; // Internal loading state
        this.onLoadingChange = null; // Callback for loading state changes
        // Absolute path (from myajax, localized in functions.php via get_stylesheet_directory_uri())
        // rather than a relative "../" path - a relative path breaks once the current URL is
        // nested more than one segment deep, since "../" only pops a single path segment
        // instead of resolving back to the site root.
        this.proxyUrl = (typeof myajax !== 'undefined' && myajax.proxy_url) || '../wp-content/themes/gruuun-theme/api-proxi.php';
        this.debounceDelay = 300;
        this.loading = false;
        this.contractNumberValue = '';
        this.uploadedFiles = [];
        this.uploadedPhotos = [];

        this.getContractValue();

        this.initializeEventListeners();

        this.renderForm();
    }

    // Getter for loading state
    get loading() {
        return this._loading;
    }

    // Setter for loading state with additional logic
    set loading(value) {
        if (this._loading !== value) {
            this._loading = value;
            // Trigger callback if defined
            if (typeof this.onLoadingChange === "function") {
                this.onLoadingChange(value);
            }
        }
    }

    getContractValue() {
        let searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('id')) {
            this.contractNumberValue = searchParams.get('id');
        }
    }

    // Initialize form logic
    initializeForm() {
        return new Promise((resolve, reject) => {
            try {
                this.initializeUploader();
                this.initializeMobUploader();
                this.initializeDatePickers();
                resolve();
            } catch (error) {
                reject('Failed to setup uploader.');
            }
        });
    }

    initializeUploader() {
        const popup = document.getElementById('popup-file-uploader-desktop');
        const dropZone = document.getElementById('drop-zone');
        const uploadArea = popup.querySelector('.upload-area');
        const fileInput = document.getElementById('file-input');

        if (!popup || !dropZone || !fileInput) return;

        // trigger file input on click
        dropZone.addEventListener('click', () => fileInput.click());

        // handle manual file input
        fileInput.addEventListener('change', (e) => {
            if (e.target.files.length > 0) {
                this.handleUploadedFile(e.target.files[0], e.target);
            }
        });

        // centralized drag events
        ['dragenter', 'dragover'].forEach(eventName => {
            popup.addEventListener(eventName, (e) => {
                e.preventDefault();
                e.stopPropagation();

                const isOpen = popup.classList.contains('-open');
                const isUploadVisible = !uploadArea.classList.contains('-hidden');

                if (isOpen && isUploadVisible) {
                    dropZone.classList.add('dragover');
                }
            });
        });

        ['dragleave', 'drop'].forEach(eventName => {
            popup.addEventListener(eventName, (e) => {
                e.preventDefault();
                e.stopPropagation();

                dropZone.classList.remove('dragover');
            });
        });

        popup.addEventListener('drop', (e) => {
            e.preventDefault();
            const files = e.dataTransfer.files;
            if (files.length > 0) {
                this.handleUploadedFile(files[0], fileInput);
            }
        });
    }

    initializeMobUploader() {
        const fileInputMob = document.getElementById('file-input-mob');
        const photoInputMob = document.getElementById('file-photo-mob');
        const addPhoto = document.getElementById('add-photo');

        if (!fileInputMob) return;

        fileInputMob.addEventListener('change', (e) => {
            if (e.target.files.length > 0) {
                this.handleUploadedFileMob(e.target.files[0]);
            }
        });

        photoInputMob.addEventListener('change', (e) => {
            if (e.target.files.length > 0) {
                this.handleUploadedPhotoMob(e.target.files[0]);
            }
        });

        addPhoto.addEventListener('click', () => photoInputMob.click());
    }

    handleUploadedFile(file) {
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/heic'];
        const maxSize = 20 * 1024 * 1024;

        const responseErrorsUploads = $('#popup-file-uploader-desktop .response-errors-uploads');
        const uploadDescription = $('#popup-file-uploader-desktop .drop-zone .upload-description');
        const uploadHeading = $('#popup-file-uploader-desktop .upload-area .upload-heading');
        const iconSvg = $('#popup-file-uploader-desktop .drop-zone .icon');

        if (!allowedTypes.includes(file.type)) {
            responseErrorsUploads.html('<div class="error">Dateiformat nicht erkannt</div><div class="hint">Bitte versuche es mit einer anderen Datei.</div>');
            uploadDescription.html('Ziehe Deine Dateien hier her oder lade sie hoch');
            uploadHeading.html('Deine Uploads');
            iconSvg.html('<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path fill-rule="evenodd" clip-rule="evenodd" d="M18.457 20.707C18.0665 21.0975 17.4335 21.0975 17.043 20.707C16.6524 20.3164 16.6524 19.6834 17.043 19.2929L23.293 13.0429C23.6835 12.6524 24.3165 12.6524 24.707 13.0429L30.957 19.2929L31.0254 19.3691C31.3457 19.7618 31.3231 20.3408 30.957 20.707C30.5909 21.0731 30.0119 21.0957 29.6191 20.7753L29.543 20.707L25 16.164L25 26.9999C25 27.5522 24.5523 27.9999 24 27.9999C23.4477 27.9999 23 27.5522 23 26.9999L23 16.164L18.457 20.707ZM13 31.8749V29.3749C13 28.8226 13.4477 28.3749 14 28.3749C14.5523 28.3749 15 28.8226 15 29.3749V31.8749L15.0078 32.0234C15.042 32.3667 15.1934 32.6894 15.4395 32.9355C15.7208 33.2168 16.1022 33.3749 16.5 33.3749H31.5C31.8978 33.3749 32.2792 33.2168 32.5605 32.9355C32.8419 32.6542 33 32.2727 33 31.8749V29.3749C33 28.8226 33.4477 28.3749 34 28.3749C34.5523 28.3749 35 28.8226 35 29.3749V31.8749C35 32.8032 34.631 33.6932 33.9746 34.3495C33.3182 35.0059 32.4283 35.3749 31.5 35.3749H16.5C15.5717 35.3749 14.6818 35.0059 14.0254 34.3495C13.4101 33.7342 13.0469 32.9137 13.0039 32.0488L13 31.8749Z" fill="#E7E7E7"/>\n' +
                '</svg>');
            return;
        }

        if (file.size > maxSize) {
            responseErrorsUploads.html('<div class="error">Deine Datei ist zu groß</div><div class="hint">Die Datei darf nicht größer als 20 MB sein.</div>');
            uploadDescription.html('Ziehe Deine Dateien hier her oder lade sie hoch');
            uploadHeading.html('Deine Uploads');
            iconSvg.html('<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path fill-rule="evenodd" clip-rule="evenodd" d="M18.457 20.707C18.0665 21.0975 17.4335 21.0975 17.043 20.707C16.6524 20.3164 16.6524 19.6834 17.043 19.2929L23.293 13.0429C23.6835 12.6524 24.3165 12.6524 24.707 13.0429L30.957 19.2929L31.0254 19.3691C31.3457 19.7618 31.3231 20.3408 30.957 20.707C30.5909 21.0731 30.0119 21.0957 29.6191 20.7753L29.543 20.707L25 16.164L25 26.9999C25 27.5522 24.5523 27.9999 24 27.9999C23.4477 27.9999 23 27.5522 23 26.9999L23 16.164L18.457 20.707ZM13 31.8749V29.3749C13 28.8226 13.4477 28.3749 14 28.3749C14.5523 28.3749 15 28.8226 15 29.3749V31.8749L15.0078 32.0234C15.042 32.3667 15.1934 32.6894 15.4395 32.9355C15.7208 33.2168 16.1022 33.3749 16.5 33.3749H31.5C31.8978 33.3749 32.2792 33.2168 32.5605 32.9355C32.8419 32.6542 33 32.2727 33 31.8749V29.3749C33 28.8226 33.4477 28.3749 34 28.3749C34.5523 28.3749 35 28.8226 35 29.3749V31.8749C35 32.8032 34.631 33.6932 33.9746 34.3495C33.3182 35.0059 32.4283 35.3749 31.5 35.3749H16.5C15.5717 35.3749 14.6818 35.0059 14.0254 34.3495C13.4101 33.7342 13.0469 32.9137 13.0039 32.0488L13 31.8749Z" fill="#E7E7E7"/>\n' +
                '</svg>');
            return;
        }

        responseErrorsUploads.empty();
        uploadDescription.html('Lege Deine Dateien in diesem Feld ab oder wähle sie manuell aus.');
        uploadHeading.html('Datei hochladen');
        iconSvg.html('<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.667 33.333V14.667C13.667 12.6419 15.3089 11 17.334 11H26.667C26.6813 11 26.6956 11.0003 26.7098 11.0009C26.9738 11.012 27.2114 11.1255 27.3838 11.3028L34.041 17.96C34.2283 18.1475 34.334 18.4019 34.334 18.667V33.333C34.334 35.3581 32.692 37 30.667 37H17.334C15.3089 37 13.667 35.3581 13.667 33.333ZM25.667 13H17.334C16.4135 13 15.667 13.7465 15.667 14.667V33.333C15.667 34.2535 16.4135 35 17.334 35H30.667C31.5875 35 32.334 34.2535 32.334 33.333V19.667H28C26.7115 19.6668 25.667 18.6216 25.667 17.333V13ZM30.9199 17.667H28C27.8161 17.6668 27.667 17.517 27.667 17.333V14.4141L30.9199 17.667ZM28.1028 24.3385L28.0003 24.3336H20.0003C19.448 24.3336 19.0003 24.7813 19.0003 25.3336C19.0005 25.8858 19.4481 26.3336 20.0003 26.3336H28.0003L28.1028 26.3278C28.6068 26.2764 29.0001 25.8511 29.0003 25.3336C29.0003 24.816 28.607 24.3898 28.1028 24.3385ZM28.1028 29.6719L28.0003 29.667H20.0003C19.448 29.667 19.0003 30.1147 19.0003 30.667C19.0005 31.2191 19.4481 31.667 20.0003 31.667H28.0003L28.1028 31.6611C28.6068 31.6098 29.0001 31.1845 29.0003 30.667C29.0003 30.1493 28.607 29.7232 28.1028 29.6719Z" fill="#E7E7E7"/></svg>');

        // 2. Показати початковий прогрес
        this.showUploadProgress(file, 'desktop');



        const total = file.size;
        const totalKB = (total / 1024).toFixed(0);

        const fileSizeKB = file.size / 1024;
        let duration = 500 + ((fileSizeKB - 1) * (3000 - 500)) / (20480 - 1);

        if (fileSizeKB <= 1) {
            duration = 500;
        } else if (fileSizeKB >= 20480) {
            duration = 3000;
        }

        const steps = 100; // кількість кадрів
        const interval = duration / steps;
        let step = 0;

        const timer = setInterval(() => {
            step++;
            const percent = Math.min((step / steps) * 100, 100);
            const loaded = Math.floor((percent / 100) * total);
            const loadedKB = (loaded / 1024).toFixed(0);

            $('.file-uploading .file-size').text(`${loadedKB} KB von ${totalKB} KB`);
            $('.progress-line .filled').css('width', `${percent}%`);

            if (step >= steps) {
                clearInterval(timer);

                // 3. Додати файл у масив
                this.uploadedFiles.push({
                    name: file.name,
                    size: file.size,
                    data: file
                });

                // 4. Сховати прогрес
                this.hideUploadProgress('desktop');

                // 5. Оновити UI
                this.renderUploadedFilesUI();
            }
        }, interval);

        this.clearUploadRequiredError();
    }

    handleUploadedFileMob(file) {
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/heic'];
        const maxSize = 20 * 1024 * 1024;

        const responseErrorsUploads = $('#popup-file-uploader-mobile .response-errors-uploads');
        const uploadDescription = $('#popup-file-uploader-mobile .upload-description');
        const uploadHeading = $('#popup-file-uploader-mobile .upload-area .upload-heading');

        if (!allowedTypes.includes(file.type)) {
            responseErrorsUploads.html('<div class="error">Dateiformat nicht erkannt</div><div class="hint">Bitte versuche es mit einer anderen Datei.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        if (file.size > maxSize) {
            responseErrorsUploads.html('<div class="error">Deine Datei ist zu groß</div><div class="hint">Die Datei darf nicht größer als 20 MB sein.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        responseErrorsUploads.empty();
        uploadDescription.show();
        uploadHeading.html('Datei hochladen').css('text-align', 'center');

        // 2. Показати початковий прогрес
        this.showUploadProgress(file, 'mobile');



        const total = file.size;
        const totalKB = (total / 1024).toFixed(0);

        const fileSizeKB = file.size / 1024;
        let duration = 500 + ((fileSizeKB - 1) * (3000 - 500)) / (20480 - 1);

        if (fileSizeKB <= 1) {
            duration = 500;
        } else if (fileSizeKB >= 20480) {
            duration = 3000;
        }

        const steps = 100; // кількість кадрів
        const interval = duration / steps;
        let step = 0;

        const timer = setInterval(() => {
            step++;
            const percent = Math.min((step / steps) * 100, 100);
            const loaded = Math.floor((percent / 100) * total);
            const loadedKB = (loaded / 1024).toFixed(0);

            $('.file-uploading .file-size').text(`${loadedKB} KB von ${totalKB} KB`);
            $('.progress-line .filled').css('width', `${percent}%`);

            if (step >= steps) {
                clearInterval(timer);

                // 3. Додати файл у масив
                this.uploadedFiles.push({
                    name: file.name,
                    size: file.size,
                    data: file
                });

                // 4. Сховати прогрес
                this.hideUploadProgress('mobile');

                // 5. Оновити UI
                this.renderUploadedFilesUI();
            }
        }, interval);

        this.clearUploadRequiredError();
    }

    handleUploadedPhotoMob(file) {
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/heic'];
        const maxSize = 20 * 1024 * 1024;

        const responseErrorsUploads = $('#popup-file-uploader-mobile .response-errors-uploads');
        const uploadDescription = $('#popup-file-uploader-mobile .upload-description');
        const uploadHeading = $('#popup-file-uploader-mobile .upload-area .upload-heading');

        if (!allowedTypes.includes(file.type)) {
            responseErrorsUploads.html('<div class="error">Dateiformat nicht erkannt</div><div class="hint">Bitte versuche es mit einer anderen Datei.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        if (file.size > maxSize) {
            responseErrorsUploads.html('<div class="error">Deine Datei ist zu groß</div><div class="hint">Die Datei darf nicht größer als 20 MB sein.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        if (!file || !(file instanceof File) || file.size === 0 || !file.type || !file.name) {
            responseErrorsUploads.html('<div class="error">Ein Fehler ist aufgetreten</div><div class="hint">Wir konnten Dein Foto nicht hochladen. Bitte versuche es erneut oder lade ein Dokument hoch.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        responseErrorsUploads.empty();
        uploadDescription.show();
        uploadHeading.html('Datei hochladen').css('text-align', 'center');

        // 2. Показати початковий прогрес
        this.showUploadProgress(file, 'mobile', true);



        const total = file.size;
        const totalKB = (total / 1024).toFixed(0);

        const duration = 2000; // у мс
        const steps = 100; // кількість кадрів
        const interval = duration / steps;
        let step = 0;

        const timer = setInterval(() => {
            step++;
            const percent = Math.min((step / steps) * 100, 100);
            const loaded = Math.floor((percent / 100) * total);
            const loadedKB = (loaded / 1024).toFixed(0);

            $('.file-uploading .file-size').text(`${loadedKB} KB von ${totalKB} KB`);
            $('.progress-line .filled').css('width', `${percent}%`);

            if (step >= steps) {
                clearInterval(timer);

                this.uploadedPhotos.push({
                    name: file.name,
                    size: file.size,
                    data: file
                });

                // 4. Сховати прогрес
                this.showPhotoArea();
            }
        }, interval);
    }

    initializeDatePickers() {
        this.setupFlatpickr(SELECTORS.DATE_PICKER);
    }

    setupFlatpickr(selector, additionalOptions = {}) {
        setTimeout(() => {
            $(selector).each(function () {
                const $pickerElement = $(this);

                const flatpickrInstance = $pickerElement.flatpickr({
                    locale: German,
                    altInput: true,
                    altFormat: "d.m.Y",
                    dateFormat: "Y-m-d",
                    allowInput: true,
                    clickOpens: false,
                    disableMobile: true,
                    additionalOptions,
                    onValueUpdate: function(selectedDates, dateStr, instance) {
                        $pickerElement.valid();
                    },
                    onClose: function(selectedDates, dateStr, instance){
                        $pickerElement.valid();
                    }
                });

                $pickerElement.closest(SELECTORS.FIELD_CONTAINER).find(SELECTORS.DATE_ICON).on("click", function () {
                    flatpickrInstance.open();
                });
            });
        }, 10);
    }


    validateForm() {
        this.setupValidationMessages();
        this.setupValidationMethods();
        this.setupFormValidation();
        this.checkFields();
        this.showHiddenFields();
    }

    showHiddenFields() {
        $('[data-show-triggers]').each((index, element) => {
            const $container = $(element);
            const triggers = JSON.parse($container.attr('data-show-triggers').replace(/'/g, '"'));
            this.checkTriggers($container, triggers);
        });
    }

    initializeEventListeners() {
        // Global event listeners here

        $(document).on('click', SELECTORS.DATE_LABEL, (e) => this.handleDateLabelClick(e));

        $(document).on('keyup blur change', SELECTORS.ALL_INPUTS, (e) => this.handleInputValidation(e));

        // Handle input events
        $(document).on('input', SELECTORS.NINJA_FORMS_FIELD, (e) => this.handleInputEvent(e));

        // Handle focus events
        $(document).on('focus', SELECTORS.NINJA_FORMS_FIELD, (e) => this.handleFocusEvent(e));

        // Handle blur events
        $(document).on('blur', SELECTORS.NINJA_FORMS_FIELD, (e) => this.handleBlurEvent(e));

        // Handle date input events
        $(document).on('focus', SELECTORS.DATE_INPUT, (e) => this.handleDateInputFocus(e));
        $(document).on('blur', SELECTORS.DATE_INPUT, (e) => this.handleDateInputBlur(e));


        $(document).on('submit', SELECTORS.FORM, this.handleFormSubmit.bind(this));

        this.onLoadingChange = (isLoading) => {
            if (isLoading) {
                $(SELECTORS.SUBMIT_BUTTON).prop('disabled', true).addClass('-loading');
            } else {
                $(SELECTORS.SUBMIT_BUTTON).prop('disabled', false).removeClass('-loading');
            }
        };
    }

    renderUploadedFilesUI() {
        const initBox = $('.initial-upload-box');
        const hiddenBox = $('.hidden-upload-box');
        const container = $('.uploaded-files-list');

        container.empty();

        if(this.uploadedFiles.length > 0) {
            this.uploadedFiles.forEach((file, index) => {
                const html = `
                    <div class="upload-entry" data-index="${index}">
                        <div class="file-name text-3">${file.name}</div>
                        <div class="file-size text-3">${(file.size / 1024).toFixed(0)} KB</div>
                        <button class="delete-upload" data-index="${index}"></button>
                    </div>
                `;
                container.append(html);
            });

            if(!initBox.hasClass('-hidden') && !hiddenBox.hasClass('-visible')) {
                initBox.addClass('-hidden');
                hiddenBox.addClass('-visible');
            }
        } else {
            initBox.removeClass('-hidden');
            hiddenBox.removeClass('-visible');
        }
    }

    handleDateLabelClick(event) {
        event.preventDefault();

        const $label = $(event.currentTarget);
        const fieldId = $label.attr('for');
        let $currentField = $(`#${fieldId}`);

        if ($currentField.length > 0 && $currentField.attr('type') === 'hidden') {
            $currentField = $currentField.next();
        }

        $currentField.focus();
    }

    showUploadProgress(file, device, photo = false) {
        const correctPopup = device === 'desktop'? $('#popup-file-uploader-desktop') : $('#popup-file-uploader-mobile');
        const uploadArea = correctPopup.find('.upload-area');
        const progressArea = correctPopup.find('.progress-area');
        const fileUploading = correctPopup.find('.file-uploading .file-info');
        const fileUploadingBox = correctPopup.find('.file-uploading');
        const photoArea = correctPopup.find('.photo-area');

        if(photo) {
            fileUploadingBox.addClass('-photo');
        } else {
            fileUploadingBox.removeClass('-photo');
        }

        const html = `
            <div class="file-name text-3">${file.name}</div>
            <div class="file-size text-3">0 KB von ${(file.size / 1024).toFixed(0)} KB</div>
        `;
        fileUploading.html(html);

        if(!progressArea.hasClass('-visible')) {
            uploadArea.addClass('-hidden');
            progressArea.addClass('-visible');
            photoArea.removeClass('-visible');
        }
    }

    hideUploadProgress(device) {
        const popupUpload = device === 'desktop'? $('#popup-file-uploader-desktop') : $('#popup-file-uploader-mobile');
        const uploadArea = popupUpload.find('.upload-area');
        const progressArea = popupUpload.find('.progress-area');
        const progressLineFilled = popupUpload.find('.progress-line .filled');
        const fileUploading = popupUpload.find('.file-uploading .file-info');
        const photoArea = popupUpload.find('.photo-area');

        popupUpload.removeClass('-open');
        $('body').removeClass('overflow-hidden');

        fileUploading.empty();
        progressLineFilled.css('width', `0%`);
        uploadArea.removeClass('-hidden');
        progressArea.removeClass('-visible');
        photoArea.removeClass('-visible');
    }

    showPhotoArea() {
        const popupUpload = $('#popup-file-uploader-mobile');
        const uploadArea = popupUpload.find('.upload-area');
        const progressArea = popupUpload.find('.progress-area');
        const photoArea = popupUpload.find('.photo-area');
        const countDiv = popupUpload.find('.photos-count');

        const container = $('.photos-list');
        const photoItems = container.find('.item-default');
        const photoCount = this.uploadedPhotos.length;

        photoItems.remove();

        if(photoCount > 0) {
            if(photoCount > 1) {
                countDiv.html(`(${photoCount} Fotos)`);
            } else {
                countDiv.html(`(${photoCount} Foto)`);
            }

            this.uploadedPhotos.forEach((file, index) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const base64 = e.target.result;

                    const html = `
                    <div class="item-default" data-index="${index}" style="background-image: url('${base64}')">
                        <button class="delete-photo" data-index="${index}"></button>
                    </div>
                `;
                    if(container.hasClass('mCustomScrollbar')) {
                        container.find('.mCSB_container').append(html);
                    } else {
                        container.append(html);
                    }
                };
                reader.readAsDataURL(file.data);
            });

            if (container.hasClass('mCustomScrollbar')) {
                container.mCustomScrollbar('destroy');
            }

            setTimeout(() => {
                container.mCustomScrollbar({
                    theme: 'light-thick',
                    axis: 'x',
                    contentTouchScroll: 25,
                    advanced: {
                        updateOnContentResize: true
                    },
                    mouseWheel: {
                        enable: true
                    }
                });
            }, 0);

            uploadArea.addClass('-hidden');
            progressArea.removeClass('-visible');
            photoArea.addClass('-visible');
        } else {
            uploadArea.removeClass('-hidden');
            progressArea.removeClass('-visible');
            photoArea.removeClass('-visible');
        }
    }

    pushPhotos() {
        const popupUpload = $('#popup-file-uploader-mobile');
        const uploadArea = popupUpload.find('.upload-area');
        const progressArea = popupUpload.find('.progress-area');
        const photoArea = popupUpload.find('.photo-area');


        if (Array.isArray(this.uploadedPhotos) && this.uploadedPhotos.length > 0) {
            this.uploadedPhotos.forEach(photo => {
                this.uploadedFiles.push(photo);
            });

            this.hideUploadProgress('mobile');

            this.renderUploadedFilesUI();

            this.uploadedPhotos = [];

            popupUpload.removeClass('-open');
            $('body').removeClass('overflow-hidden');

            uploadArea.removeClass('-hidden');
            progressArea.removeClass('-visible');
            photoArea.removeClass('-visible');
        }
    }

    showLoader() {
        $(SELECTORS.LOADER).show();
    }

    hideLoader() {
        $(SELECTORS.LOADER).hide();
    }

    setupValidationMessages() {
        $.extend($.validator.messages, {
            required: "Dieses Feld wird benötigt.",
            email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            number: "Bitte geben Sie eine gültige Zahl ein.",
            range: $.validator.format("Bitte geben Sie einen Wert zwischen {0} und {1} ein."),
            max: $.validator.format("Bitte geben Sie einen Wert kleiner oder gleich {0} ein."),
            min: $.validator.format("Bitte geben Sie einen Wert größer oder gleich {0} ein."),
            digits: "Nur Zahlen sind erlaubt.",
            rangelength: $.validator.format("Bitte geben Sie genau {0} Zeichen ein.")
        });
    }

    setupValidationMethods() {
        $.validator.addMethod("notOlderThan3Days", function (value, element) {
            if (!value) return this.optional(element);

            const selectedDate = new Date(value);
            const currentDate = new Date();

            selectedDate.setHours(0, 0, 0, 0);
            currentDate.setHours(0, 0, 0, 0);

            const threeDaysAgo = new Date(currentDate);
            threeDaysAgo.setDate(currentDate.getDate() - 3);

            return this.optional(element) ||
                (selectedDate >= threeDaysAgo && selectedDate <= currentDate);
        }, "Bitte wähle ein Datum innerhalb der letzten 3 Tage (einschließlich heute).");

    }

    setupFormValidation(form) {

        $(SELECTORS.FORM).validate({
            ignore: ".datepicker.input",
            rules: {
                meterReading: {
                    digits: true,
                },
                meterReadingHT: {
                    digits: true,
                },
                meterReadingNT: {
                    digits: true,
                },
                ablesedatum: { notOlderThan3Days: true },

            },
            errorPlacement: function (error, element) {
                error.appendTo(element.closest('.field-wrap').find('.nf-error-msg'));
            },
            highlight: function (element) {
                $(element).closest('.field-wrap').addClass('nf-error').removeClass('nf-pass');
            },
            unhighlight: function (element) {
                $(element).closest('.field-wrap').removeClass('nf-error');
            },
            success: function (label, element) {
                if($(element).val() !== '') {
                    $(element).closest('.field-wrap').addClass('nf-pass');
                }
            },
        });
    }

    handleInputValidation(event) {
        let $input = $(event.currentTarget);
        const $attr = $input.attr('required');
        const $container = $input.closest(SELECTORS.FIELD_CONTAINER);
        const $wrap = $input.closest('.field-wrap');

        if ($input.length > 0) {
            if ($input.attr('type') === 'hidden') {
                $input = $input.next();
            }
        }

        // Validate the input
        $(SELECTORS.FORM).validate().element($input[0]);

        // Add or remove "fake-nf-pass" based on the input value
        if (($input.is('[type="text"]') || $input.is('[type="number"]') || $input.is('[type="tel"]') || $input.is('[type="date"]')) && !$attr) {
            if ($input.val().trim() !== '') {
                $container.addClass('fake-nf-pass');
            } else {
                $container.removeClass('fake-nf-pass');
                $wrap.removeClass('nf-pass');
            }
        }
    }

    handleInputEvent(event) {
        const $input = $(event.currentTarget);
        const $attr = $input.attr('required');
        const $container = $input.closest(SELECTORS.FIELD_CONTAINER);
        let value = $input.val();

        if ($input.is('select[multiple]')) {
            value = Array.isArray(value) && value.length > 0 ? value.join('').trim() : '';
        } else if ($input.is('select')) {
            value = value ? value.trim() : '';
        } else if (typeof value === 'string') {
            value = value.trim();
        } else {
            value = '';
        }

        $container.removeClass('potentially-required-label');
        if (value !== '') {
            $container.addClass('label-up');
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.removeClass('required-label');
            }
        } else {
            $container.removeClass('label-up');
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.addClass('required-label');
            }
        }
    }

    handleFocusEvent(event) {
        const $input = $(event.currentTarget);
        const $container = $input.closest(SELECTORS.FIELD_CONTAINER);

        $container.addClass('label-focus');
        $container.removeClass('potentially-required-label');
    }

    handleBlurEvent(event) {
        const $input = $(event.currentTarget);
        const $attr = $input.attr('required');
        const $container = $input.closest(SELECTORS.FIELD_CONTAINER);

        $container.removeClass('potentially-required-label');
        $container.removeClass('label-focus');
        if ($input.val().trim() === '') {
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.addClass('required-label');
            }
        } else {
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.removeClass('required-label');
            }
        }
    }

    // Check Ninja Forms fields
    checkFields() {
        $(SELECTORS.ALL_INPUTS).each(function () {
            let $input = $(this);
            let $attr = $input.attr('required');
            let $container = $input.closest(SELECTORS.FIELD_CONTAINER);

            $container.addClass('active-label');
            if (!$input.is('select') && !$input.is('input[type=checkbox]') && !$input.is('input[type=radio]')) {
                if ($input.val().trim() !== '') {
                    $container.addClass('label-up');
                } else {
                    $container.removeClass('label-up');
                }
            }
            if (typeof $attr !== 'undefined' && $attr !== false && ((!$.isArray($input.val()) && $input.val().trim() === '') || ($.isArray($input.val()) && $input.val().length > 0))) {
                $container.addClass('potentially-required-label');
            }

            if (($input.is('[type="text"]') || $input.is('[type="email"]') || $input.is('[type="tel"]') || $input.is('[type="number"]') || $input.is('[type="date"]')) && $input.val().trim() !== '') {
                $(SELECTORS.FORM).validate().element($input[0]);
            }

            if (($input.is('[type="text"]') || $input.is('[type="number"]') || $input.is('[type="tel"]') || $input.is('[type="date"]')) && !$attr && $input.val().trim() !== '') {
                $container.addClass('fake-nf-pass');
            }
        });
    }

    handleDateInputFocus(event) {
        const $input = $(event.currentTarget);
        $input.inputmask({
            mask: "99.99.9999",
            placeholder: "tt.mm.jjjj",
            clearIncomplete: true,
        });
    }

    handleDateInputBlur(event) {
        const $input = $(event.currentTarget);
        $input.inputmask('remove');
        $input.attr('placeholder', '');
    }

    checkContractNumber() {
        if (this.loading === true) {
            return;
        }
        this.loading = true;
        this.showLoader();

        let sendData = {};

        if (this.contractNumberValue) {
            sendData.contractNumber = this.contractNumberValue;

            return new Promise((resolve, reject) => {
                $.ajax({
                    url: `${this.proxyUrl}?type=checkContractNumber`,
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify(sendData),
                    success: function (response) {
                        resolve(response);
                    },
                    error: function (xhr, status, error) {
                        reject(error);
                    }
                });
            });
        } else {
            return Promise.reject('ContractNumber is missing in URL parameters');
        }
    }

    getEmptyForm() {
        if (this.loading === true) {
            return;
        }
        this.loading = true;
        this.showLoader();
        const bodyClass = $('body').attr('class');
        const pageIdMatch = bodyClass.match(/page-id-(\d+)/);
        const pageId = pageIdMatch ? pageIdMatch[1] : null;

        return new Promise((resolve, reject) => {
            $.ajax({
                url: myajax.url,
                method: 'POST',
                data: {
                    action: 'get_form_ad_campaign',
                    page_id: pageId,
                    nonce: myajax.nonces.get_form_ad_campaign,
                },
                success: function (response) {
                    if (response.data && response.data.form) {
                        $(SELECTORS.FORM_CONTAINER).html(response.data.form);
                        resolve();
                    } else {
                        reject('Empty response or form data is missing.');
                    }
                },
                error: function (xhr, status, error) {
                    reject(error);
                }
            });
        });
    }

    checkTriggers($container, triggers) {
        let shouldShow = true;

        for (let trigger in triggers) {
            const expectedValue = triggers[trigger];
            const inputTrigger = $('input[name=' + trigger + ']');
            let inputValue = '';

            if (inputTrigger.attr('type') === 'checkbox') {
                inputValue = inputTrigger.is(':checked') ? 'true' : 'false';
            } else if (inputTrigger.attr('type') === 'radio') {
                inputValue = $('input[name=' + trigger + ']:checked').val();
            }

            if (inputValue !== expectedValue) {
                shouldShow = false;
                break;
            }
        }

        if (shouldShow) {
            $container.addClass('-show');

            if(!$container.hasClass('show-trigger-container')) {
                let checkRequired = $container.hasClass('required-if-showed');
                let triggeredInput = $container.find('input, select');

                if (checkRequired) {
                    $container.removeClass('required-if-showed');
                    triggeredInput.attr('required', true);
                }
            }
        } else {
            $container.removeClass('-show');

            if(!$container.hasClass('show-trigger-container')) {
                let triggeredInput = $container.find('input, select');
                let checkRequired = typeof triggeredInput.attr('required') !== 'undefined' && triggeredInput.attr('required') !== false;

                if (checkRequired) {
                    $container.addClass('required-if-showed');
                    $container.find('input, select').attr('required', false);
                }
            }

            this.clearContainerTextInputs($container);
        }
    }

    clearContainerTextInputs($container) {
        const $inputs = $container.find('input')
            .not('[type="radio"], [type="checkbox"], [type="button"], [type="submit"]');

        $inputs.each(function () {
            const $f = $(this);

            $f.val('');

            $f.trigger('input').trigger('change');

            const $wrap = $f.closest('.field-wrap');
            $wrap.removeClass('nf-pass nf-error');
            $wrap.find('.nf-error-msg').empty();
        });
    }


    renderForm() {
        let sendData = {};

        if (!this.contractNumberValue) {
            $(SELECTORS.FORM_CONTAINER).html(`<div class="page-title error-token"><h1>Herzlich Willkommen!</h1> <div class="text-2"><p>Diese Seite ist nur mit einer gültigen Vertragsnummer zugänglich.</p></div></div>`);
            return;
        }

        this.getEmptyForm()
            .then(() => {
                this.hideLoader();
                this.loading = false;

                return this.initializeForm();
            })
            .then(() => {
                this.validateForm();
            })
            .catch(error => {
                this.hideLoader();
                this.loading = false;

                console.error('Failed to render form:', error);
                $(SELECTORS.FORM_CONTAINER).html(
                    `<div class="page-title error-token">
                                <h1>Leider haben wir Deinen Vertrag mit der Vertragsnummer nicht in unserem System gefunden. Bitte wende Dich an den Kundenservice.</h1>
                            </div>`
                );
            });
    }

    createSendData() {
        let sendDataRaw = {};
        let self = this;

        if (!this.contractNumberValue) {
            console.error('contractNumber is missing.');
            this.loading = false;
            return;
        }


        if (this.contractNumberValue) {
            return new Promise((resolve, reject) => {
                sendDataRaw.vertragsnummer = this.contractNumberValue;
                sendDataRaw.ablesedatum = $(SELECTORS.ABLESEDATUM_INPUT).val();

                switch ($(SELECTORS.SWITCHER_RADIO_CHECKED).val()) {
                    case 'singleRate':
                        sendDataRaw.zaehlerstand = $(SELECTORS.METER_READING_INPUT).val();
                        break;

                    case 'doubleRate':
                        sendDataRaw.zaehlerstand_HT = $(SELECTORS.METER_READING_HT_INPUT).val();
                        sendDataRaw.zaehlerstand_NT = $(SELECTORS.METER_READING_NT_INPUT).val();
                        break;

                    default:
                        break;
                }

                let sendData = JSON.stringify(sendDataRaw, null, 2);

                // console.log(sendData);

                resolve(sendData);
            });
        } else {
            self.loading = false;
            return Promise.reject('contractNumber is missing');
        }
    }

    sendFilesToEmail(sendData) {
        const formData = new FormData();
        const contractNumber = this.contractNumberValue;

        this.uploadedFiles.forEach((file, index) => {
            formData.append(`file_${index}`, file.data, file.name);
        });

        formData.append('action', 'send_email_with_files_v2');
        formData.append('contract_number', contractNumber);

        if(sendData) {
            formData.append('mail_body', sendData);
        }

        return new Promise((resolve, reject) => {
            $.ajax({
                url: myajax.url,
                method: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: (res) => {
                    if (res.success) {
                        resolve(res);
                    } else {
                        $('.response-errors').html('<div class="error">Fehler beim Senden der Dateien.</div>');
                        reject('Fehler beim Senden der Dateien.');
                    }
                },
                error: () => {
                    $('.response-errors').html('<div class="error">Fehler beim Upload.</div>');
                    reject('Fehler beim Upload.');
                }
            });
        });
    }

    convertTimestampToISO(timestamp) {
        if (!timestamp) return null;
        const date = new Date(parseInt(timestamp, 10));
        return date.toISOString();
    }

    showUploadRequiredError() {
        const html = '<div class="error">Bitte lade mindestens ein Foto hoch.</div>';
        $(SELECTORS.RESPONSE_ERRORS).html(html);
    }

    clearUploadRequiredError() {
        $(SELECTORS.RESPONSE_ERRORS).empty();
    }

    handleFormSubmit(event) {
        event.preventDefault();

        if (this.loading === true) {
            return; // Prevent duplicate submissions
        }

        if (this.uploadedFiles.length < 1) {
            this.clearUploadRequiredError(); // щоб не дублювати
            this.showUploadRequiredError();
            return;
        }

        this.loading = true;

        this.createSendData()
            .then((sendData) => {

                if (!sendData) {
                    throw new Error('No sendData available');
                }


                return this.sendFilesToEmail(sendData);

            })
            .then(() => {

                window.location.href = ad_campaign.success_page || `/new-success`;
            })
            .catch(error => {
                console.error('Error in chain:', error);
                this.loading = false;
            });
    }



}

// Initialize adCampaign API service
const adCampaignApiService = new AdCampaign();

$(document).on('click', '.delete-upload', function () {
    const index = $(this).data('index');
    adCampaignApiService.uploadedFiles.splice(index, 1);
    adCampaignApiService.renderUploadedFilesUI();
});

$(document).on('click', '.delete-photo', function () {
    const index = $(this).data('index');
    adCampaignApiService.uploadedPhotos.splice(index, 1);
    adCampaignApiService.showPhotoArea();
});

$(document).on('click', '#push-photos', function () {
    adCampaignApiService.pushPhotos();
});

$(document).on('click', '.upload-tooltip-opener:not(:disabled)', function (e) {
    e.preventDefault();
    const isMobileCameraCapable = () => {
        const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        const isSmallScreen = window.innerWidth <= 768;
        const hasCamera = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);

        // return isTouch && isSmallScreen && hasCamera;
        return isTouch && hasCamera;
        // return true;
    };

    if (isMobileCameraCapable()) {
        $('#popup-file-uploader-mobile').addClass('-open');
    } else {
        $('#popup-file-uploader-desktop').addClass('-open');
    }
    $("body").addClass("overflow-hidden");
});

//Combine event handlers for close buttons and modal overlays.
$(document).on("click", ".upload-popup .close-button, .upload-popup .modal-overlay", function (e) {
    const modalPopup = $(this).closest(".upload-popup");

    modalPopup.removeClass("-open");
    $("body").removeClass("overflow-hidden");
});

$(document).on('change', SELECTORS.SWITCHER_RADIO, (e) => {
    adCampaignApiService.showHiddenFields();
});